import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import React, { Component } from 'react';
import {
  Col,
  FormControl,
  FormGroup,
  Grid,
  InputGroup,
  Navbar,
  Row
} from 'react-bootstrap';
import { connect } from 'react-redux';
// react component for creating dynamic tables
import ReactTable from 'react-table';
//Redux
import { bindActionCreators } from 'redux';
import * as CategoriesActions from './redux/CategoriesActions';

class CategoriesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
    console.log('Props', props);
  }

  componentWillMount() {
    this.props.find({
      include: ['client']
    });
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  render() {
    let _this = this;
    let { history, Categories } = this.props;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Categorías'}{' '}
                    <div className="pull-right header-table">
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() => history.push('/admin/categories/create')}
                      >
                        Agregar Categoría
                      </Button>
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={Categories.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    data={
                      Categories.searchData
                        ? Categories.searchData
                        : Categories.data
                    }
                    page={Categories.table.page}
                    sorted={Categories.table.sorted}
                    filtered={Categories.table.filtered}
                    pageSize={Categories.table.pageSize}
                    onSortedChange={change =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={change =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={change =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={change =>
                      _this.props.changeTable('pageSize', change)
                    }
                    filterable
                    columns={[
                      {
                        Header: 'Nombre',
                        accessor: 'name',
                        minWidth: 120
                      },
                      {
                        Header: 'Actions',
                        accessor: 'actions',
                        sortable: false,
                        filterable: false,
                        Cell: props => (
                          // we've added some custom button actions
                          <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <Button
                              onClick={() =>
                                history.push(
                                  '/admin/categories/' + props.original.id
                                )
                              }
                              bsStyle="warning"
                              simple
                            >
                              Editar
                            </Button>{' '}
                            {/* <Switch
                                                            onText="On"
                                                            offText="Off"
                                                        /> */}
                          </div>
                        )
                      }
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    Categories: state.Categories
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(CategoriesActions, dispatch);
};

const CategoriesConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoriesIndex);

export default CategoriesConnect;



// WEBPACK FOOTER //
// ./src/views/Categories/CategoriesIndex.jsx